import { Box } from '@mui/system';
import { Divider } from '@mui/material';

import SilentRejectSetting from 'src/sections/admin/organization/settings/components/silent-reject-setting';

import AutoInviteSetting from './auto-invite-setting';
import InterviewPhasesSetting from './interview-phases-setting';
import RejectionReasonsSettings from './rejection-reasons-settings';
import ApplicationSourcesSettings from './application-sources-settings';

export default function JobApplicationSettingsCard() {
  return (
    <Box sx={{ width: '100%' }}>
      <SilentRejectSetting />
      <Divider sx={{ my: 3 }} />
      <RejectionReasonsSettings />
      <Divider sx={{ my: 3 }} />
      <InterviewPhasesSetting />
      <Divider sx={{ my: 3 }} />
      <ApplicationSourcesSettings />
      <Divider sx={{ my: 3 }} />
      <AutoInviteSetting />
    </Box>
  );
}